import { useMutation } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import {
  buildPartnerCompanyInfoFormData,
  mergePartnerProfileWithCompanyInfo,
  updatePartnerCompanyInfo,
} from '../services/partnerCompanyInfo';

export const useUpdatePartnerCompanyInfoMutation = (options = {}) => {
  const { updatePartnerProfile } = useAuth();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ form }) => {
      const formData = buildPartnerCompanyInfoFormData(form);
      const result = await updatePartnerCompanyInfo(formData);
      if (!result.success) {
        throw new Error(result.message || 'Failed to update company info');
      }
      return result;
    },
    onSuccess: async (result, variables, context) => {
      if (result.partnerProfile) {
        updatePartnerProfile((prev) =>
          mergePartnerProfileWithCompanyInfo(prev, result.partnerProfile),
        );
      }

      await onSuccess?.(result, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
